import http from 'plugins/axios';

export default {
  getList(data) {
    return http.get({
      url: '/la/admin/get/createOrderTaskByStatus',
      data
    });
  },
  create(data) {
    return http.post({
      url: '/la/admin/add/createOrderTask',
      data,
      dataType: 'form'
    });
  },
  delete(data) {
    return http.post({
      url: '/la/admin/delete/createOrderTask',
      data,
      dataType: 'form'
    });
  },
  getCoinTypeList() {
    return http.get({
      url: '/la/admin/coin/allDisplay'
    });
  }
};
